import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { Router } from "@angular/router"; 
import { AuthService } from "../services/auth.service";
import { ToastrService } from "ngx-toastr";
import { AppConfig } from "../config/app-config";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private translate: TranslateService, private toastr: ToastrService,private router: Router, private authService: AuthService, private appConfig: AppConfig) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    let token = this.authService.getToken()
    if (token != null) {

      const isApiUrl = req.url.startsWith(this.appConfig.urlKeysApi);
      if (isApiUrl) {
        req = req.clone({
          headers: req.headers.set('Authorization', 'Bearer ' + token)
        });
      }
      return next.handle(req).pipe(
        tap(
          succ => {
                if (!req.url.endsWith('RefreshToken') && !req.url.endsWith('Login')) { this.authService.refreshToken(); }
          },
          err => {
              this.errorHandler(err);
          }
        )
      )
    }
    else
      return next.handle(req.clone()).pipe(
        catchError(error => {
          this.errorHandler(error);
          return throwError(error);
        }));
    }
    private errorHandler(err) {
        console.log(err);
        if (err.status == 401) {
            this.authService.removeToken();
            this.router.navigateByUrl('/login');
        }
        else {
            if (err.error.translateKey)
                this.toastr.error(this.translate.instant(err.error.translateKey), this.translate.instant("COM.OPERATION_FAIL"))
            else
                this.toastr.error("", this.translate.instant("COM.OPERATION_FAIL"))
             

            console.log(err.error.Message);
        }
    }
}
